import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import KatalogiTree from './KatalogiTree';
import KatalogDodaj from './KatalogDodaj';
import KatalogUsun from './KatalogUsun';
import AlertErrorText from '../../../components/Alert/AlertErrorText';
import AlertSuccessText from '../../../components/Alert/AlertSuccessText';
import { zapiszKatalogi, getProduktKatalogi } from '../../../dao/Produkt';
export default function KatalogiDialog(props) {
  const id_produkt = props.id_produkt;
  const [open, setOpen] = useState(false);
  const [sciezka, setSciezka] = useState("brak");
  let biRefTree = {

  };
  let biRefErrorInfo = {
  };
  let biRefSuccessInfo = {
  };
  async function fetchProduktKatalogi(id_produkt) {
    let x = await getProduktKatalogi(id_produkt).catch(e => {
      return null;
    });
    console.log("fetchProduktKatalogi " + (new Date()).toLocaleTimeString());
    if (!x) {
      console.log("błąd");
      setSciezka("błąd");
    } else {
      console.log("x.fetchProduktKatalogi:" + JSON.stringify(x.katalogi));
      if (x.katalogi.length > 0) {
        let i = 0;
        let poziom=0;
        let s = x.katalogi.map((item, key) => {
          if (i > 0 && item.id_katalog_parent == "") {
            return (<><br />{item.nazwa} {katalogChild(poziom,x.katalogi,item)}</>);
          }
          if (item.id_katalog_parent == "") {
            i++;
            return (<>{item.nazwa} {katalogChild(poziom,x.katalogi,item)}</>);
          }
        })
        setSciezka(s);
      } else {
        setSciezka("brak");
      }
    }
  };
  const katalogChild = (poziom,katalogi,katalog) => {
    let i=0;
    poziom++;
    let s = katalogi.map((item, key) => {
      if (i > 0 && item.id_katalog_parent==katalog.id_katalog) {
        return (<><br/>{poziom}{"-->"}{item.nazwa} {katalogChild(poziom,katalogi,item)}</>);
      }
      if ( item.id_katalog_parent==katalog.id_katalog) {
        i++;
        return (<>{"-->"}{item.nazwa} {katalogChild(poziom,katalogi,item)}</>);
      }
    })
    return s;
  }
  useEffect(() => {
    console.log("fetchGetKatalogi: useEffect");
    fetchProduktKatalogi(id_produkt);
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };



  const handleZapisz = () => {

    console.log("handleZapisz");
    console.log("getSelectedItem: " + JSON.stringify(biRefTree.getSelectedItem()));
    let katalogi = biRefTree.getSelectedItem();
    if (katalogi.length == 0) {
      biRefErrorInfo.pokazText("Zaznacz katalogi");
      return;
    }
    const t = async () => {
      let x = await zapiszKatalogi(id_produkt, biRefTree.getSelectedItem()).catch(e => {
        biRefErrorInfo.pokazText(e.message);
        return null;
      });
      if (!x) {
        return;
      }
      if (x.error) {
        biRefErrorInfo.pokazText(x.error.info);
        return;
      } else {
        biRefSuccessInfo.pokazText("Zapisane");
        window.setTimeout(() => {
          setOpen(false);
          fetchProduktKatalogi(id_produkt);
        }, 2000);
      }
    }
    t();
  };

  const handleClose = () => {
    setOpen(false);
  };

  biRefTree.handleClose = handleClose;
  return (
    <div>
      <Button variant="outlined" color="primary" onClick={handleClickOpen} style={{ textAlign: 'right' }}>
        {sciezka}
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Wybór katalogów</DialogTitle>
        <DialogContent>
          <KatalogiTree biRef={biRefTree} />
          <AlertErrorText biRef={biRefErrorInfo} />
          <AlertSuccessText biRef={biRefSuccessInfo} />
        </DialogContent>
        <DialogActions>
          <Button color="primary">
            <KatalogUsun biRef={biRefTree} />
          </Button>
          <KatalogDodaj biRef={biRefTree} />
          <Button onClick={handleClose} color="primary">
            Anuluj
          </Button>
          <Button onClick={handleZapisz} color="primary">
            Zapisz
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}